import {classNames} from "@reactivated";
import * as React from "react";

// Fuel Meals wordmark as a currentColor mask. The artwork's letters fill the
// top 76% of the image and the speedometer arc hangs 23% below their
// baseline. 1.15em (cap height ≈ 0.87em) read best next to Inter; the
// baseline drop is the arc's 23% minus a 0.11em optical lift.
export const FuelMealsMark = (props: {className?: string}) => (
    <span
        role="img"
        aria-label="Fuel Meals"
        className={classNames(
            "inline-block aspect-[6.35] h-[1.15em] bg-current align-baseline",
            props.className,
        )}
        style={{
            verticalAlign: "-0.12em",
            WebkitMaskImage: "url(/static/images/fuelmeals-wordmark.png)",
            maskImage: "url(/static/images/fuelmeals-wordmark.png)",
            WebkitMaskSize: "contain",
            maskSize: "contain",
            WebkitMaskRepeat: "no-repeat",
            maskRepeat: "no-repeat",
            WebkitMaskPosition: "center",
            maskPosition: "center",
        }}
    />
);
